import { types } from "../constants/types";

const initialState = {

    createSubscriptionPlan : [],
    createSubscriptionPlanFailed : '',

    getSubscriptionPlan : [],
    getSubscriptionPlanFailed : '',

    getAllSubscriptionPlan : [],
    getAllSubscriptionPlanFailed : '',

    updateSubscriptionPlan : [],
    updateSubscriptionPlanFailed : '',

    deleteSubscriptionPlan: [],
    deleteSubscriptionPlanFailed: '',



    createUserSubscription : [],
    createUserSubscriptionFailed : '',

    getUserSubscription : [],
    getUserSubscriptionFailed : '',

    getAllUserSubscription : [],
    getAllUserSubscriptionFailed : '',

    getUserSubscriptionByPlanId: [],
    getUserSubscriptionByPlanIdFailed: '',

    getUserSubscriptionByUserId: [],
    resetGetUserSubscriptionByUserId: '',

    updateUserSubscription : [],
    updateUserSubscriptionFailed : '',

    deleteUserSubscription: [],
    deleteUserSubscriptionFailed: '',



}

//receives the current state and an action object
export function subscriptionReducer(state = initialState, action) {
    switch (action.type) {
        case types.CREATE_SUBSCRIPTION_PLAN_SUCCESS:
            return {
                ...state,
                createSubscriptionPlan : action.payload
            }
        case types.CREATE_SUBSCRIPTION_PLAN_FAILED:
            return {
                ...state,
                createSubscriptionPlanFailed : action.payload
            }
        case types.GET_SUBSCRIPTION_PLAN_SUCCESS:
            return {
                ...state,
                getSubscriptionPlan : action.payload
            }
        case types.GET_SUBSCRIPTION_PLAN_FAILED:
            return {
                ...state,
                getSubscriptionPlanFailed : action.payload
            }
        case types.GET_ALL_SUBSCRIPTION_PLAN_SUCCESS:
            return {
                ...state,
                getAllSubscriptionPlan : action.payload
            }
        case types.GET_ALL_SUBSCRIPTION_PLAN_FAILED:
            return {
                ...state,
                getAllSubscriptionPlanFailed : action.payload
            }    
        case types.UPDATE_SUBSCRIPTION_PLAN_SUCCESS:
            return {
                ...state,
                updateSubscriptionPlan : action.payload
            }
        case types.UPDATE_SUBSCRIPTION_PLAN_FAILED:
            return {
                ...state,
                updateSubscriptionPlanFailed : action.payload
            }
        case types.DELETE_SUBSCRIPTION_PLAN_SUCCESS:
            return {
                ...state,
                deleteSubscriptionPlan : action.payload
            }
        case types.DELETE_SUBSCRIPTION_PLAN_FAILED:
            return {
                ...state,
                deleteSubscriptionPlanFailed : action.payload
            }


        case types.CREATE_USER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                createUserSubscription : action.payload
            }
        case types.CREATE_USER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                createUserSubscriptionFailed : action.payload
            }
        case types.GET_USER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                getUserSubscription : action.payload
            }
        case types.GET_USER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                getUserSubscriptionFailed : action.payload
            }
        case types.GET_ALL_USER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                getAllUserSubscription : action.payload
            }
        case types.GET_ALL_USER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                getAllUserSubscriptionFailed : action.payload
            }
        case types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS:
            return {
                ...state,
                getUserSubscriptionByPlanId : action.payload
            }
        case types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_FAILED:
            return {
                ...state,
                getUserSubscriptionByPlanIdFailed : action.payload
            } 
        case types.GET_USER_SUBSCRIPTIONS_By_USER_ID_SUCCESS:
            return {
                ...state,
                getUserSubscriptionByUserId : action.payload
            }
        case types.GET_USER_SUBSCRIPTIONS_By_USER_ID_FAILED:
            return {
                ...state,
                getUserSubscriptionByUserIdFailed : action.payload
            }    
        case types.UPDATE_USER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                updateUserSubscription : action.payload
            }
        case types.UPDATE_USER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                updateUserSubscriptionFailed : action.payload
            }
        case types.DELETE_USER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                deleteUserSubscription : action.payload
            }
        case types.DELETE_USER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                deleteUserSubscriptionFailed : action.payload
            }
        
        default:
            return state
    }
}